import { ApiConfig } from "../../../Api/Api";

export const getChapterDataApi = async () => {
  return await ApiConfig.get(`api/chapter`);
};